import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { HeaderService } from '../../../../@theme/components/header/service/header.service';
import { Store } from '../../../../@core/store/store';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { IntranetService } from "../../intranet/service/intranet.service";
import { NbToastrService } from '@nebular/theme';
import {
  NbDialogRef,
} from "@nebular/theme";
import { AppLocalStorage } from "../../../../@core/utils/local-storage.util";
import { ForexApprovalConfirmComponent } from '../../../../../app/pages/home/dynamic-stack/forex-approval-confirm/forex-approval-confirm.component';
import { NbDialogService } from "@nebular/theme";


@Component({
  selector: 'ltts-forex-more',
  templateUrl: './forex-more.component.html',
  styleUrls: ['./forex-more.component.scss']
})
export class ForexMoreComponent implements OnInit {
  forexData: any[] = [];
  forexLoadingData: boolean;
  forexRequestsDataLoading: boolean;
  forexRequestAvailableInDate: boolean = false;
  forexReqForApprovalsData: any = [];
  accountData: any = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA");
  forexMoreData: any;
  loading: boolean = false;
  isDisabled = true;
  @Input() parentDialogRef!: NbDialogRef<any>

  constructor(private headerService: HeaderService, private cdr: ChangeDetectorRef,
    private intranetService:IntranetService,
     private toastrService: NbToastrService,
     private dialogService: NbDialogService,
     private cdRef: ChangeDetectorRef,
     
    // @Inject(DIALOG_DATA) public data: any,
    protected dialogRef: NbDialogRef<ForexMoreComponent>
  ) { }
  

  @Input() set data(value: any) {
    if (value) {
      this.forexMoreData = value;
    }
  }

  ngOnInit() {
  }

  forexRequestApproval(item: any){
    this.dialogService
      .open(ForexApprovalConfirmComponent, {
          context: {
            parentDialogRef: this.dialogRef,
            data: item,
            
      },
      hasBackdrop: true,
      closeOnBackdropClick: true,

      })
      .onClose.subscribe((result) => {
    if (result === 'approved') {
      this.forexMoreData = this.forexMoreData?.filter(emp => emp.forexId !== item.forexId);
       this.cdRef.detectChanges();
      //  this.parentDialogRef.close('approved');
    }
  });

  }

  getFormattedAmountsForEmployee(forexMoreData: any): { cash: string[], card: string[] } {
    const cash: string[] = [];
    const card: string[] = [];

    const currencyDetail = forexMoreData.currencyDetail || [];

    currencyDetail.forEach(item => {
      if (item.amountRequiredinCash !== null) {
        cash.push(`${item.currency} ${item.amountRequiredinCash}`);
      }
      if (item.amountRequiredoncard !== null) {
        card.push(`${item.currency} ${item.amountRequiredoncard}`);
      }
    });

    return { cash, card };
  }

redirectTo(url: string): void {
  if (url) {
    window.open(url, '_blank');
  }
}
  closeDialog() {
    this.dialogRef.close();
  }

}
